import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=c045f4e2&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=c045f4e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c045f4e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c045f4e2')) {
      api.createRecord('c045f4e2', component.options)
    } else {
      api.reload('c045f4e2', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=c045f4e2&scoped=true&", function () {
      api.rerender('c045f4e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4H4CWVCAKegFN/JS/comp/PopupBox.vue"
export default component.exports